/*
 * @Author       : 程哲林
 * @Date         : 2021-11-25 16:46:24
 * @LastEditors  : 程哲林
 * @LastEditTime : 2023-09-07 13:52:27
 * @FilePath     : /marketing-introduce-ssr/components/Activity/Button/index.tsx
 * @Description  : 未添加文件描述
 */

import cx from 'classnames';
import React from 'react';

import styles from './index.module.scss';

interface IProps {
  children: any;
  onClick?: React.MouseEventHandler<HTMLButtonElement>;
  className?: string;
  disabled?: boolean;
  // wx?: boolean;
  subTitle?: string;
  finger?: boolean;
}

const Button = React.memo(
  ({
    children,
    onClick,
    className = '',
    subTitle = '',
    disabled = false,
    finger = false
  }: IProps): JSX.Element => {
    return (
      <button
        type='button'
        sensors-disable='true'
        disabled={disabled}
        onClick={onClick}
        className={cx(styles.btn, className)}>
        {children}
        <span className={styles.sub}>{subTitle}</span>
        {finger ? <i /> : null}
      </button>
    );
  }
);

export { Button };
